import { useState } from 'react';
import type { StyleProp, ViewStyle } from 'react-native';

import { ListItem, RadioListItem } from './radio-list-item/radio-list-item';
import { mt } from '../../style-utils';

export interface RadioListProps<T> {
  items: ListItem<T>[];
  type?: 'primary' | 'secondary';
  value?: T;
  itemStyle?: StyleProp<ViewStyle>;
  onSelectionChanged: (value: T) => void;
}

export const RadioList = <T extends unknown>({
  items,
  type,
  value,
  itemStyle,
  onSelectionChanged,
}: RadioListProps<T>) => {
  const [selectedItem, setSelectedItem] = useState(value);

  const handleSelection = (value: any) => {
    setSelectedItem(value);
    onSelectionChanged(value);
  };

  return (
    <>
      {items.map((item, index) => (
        <RadioListItem<T>
          testId={JSON.stringify(item.value)}
          key={item.value + '_' + index}
          style={[index !== 0 && mt(16), itemStyle]}
          type={type}
          onSelection={(value) => handleSelection(value)}
          selected={selectedItem === item.value}
          value={item.value}
          label={item.label}
          description={item.description}
        />
      ))}
    </>
  );
};
